import Quill from "quill/dist/quill.js";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css"
import _ from "lodash";
import "./RichEditor.scss";
import { popinfo } from "../Fancybox/Fancybox";
import api from "../../api";

const QuillBuilder = (element, authToken, modules) => {

    return new Quill(element, {
        placeholder: 'Type...'
        ,theme: 'snow'
        ,modules: _.assignIn({}, {
            toolbar: {
                container :
                [
                    [{ header: ['1', '2', '3', false] }],
                    ['bold', 'italic', 'underline', 'strike' , { 'align': [] }],
                    [{ 'script': 'sub'}, { 'script': 'super' }],
                    [{ list: 'ordered' }, { list: 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }],
                    [{ 'size': ['small', false, 'large'] }],
                    authToken ? ['link', 'image'] : ['link']
                ]
                ,handlers: authToken ? {
                    'image': function(){
                        /**
                         * Reference https://github.com/quilljs/quill/issues/2034
                         */
                        const input = document.createElement('input');
                        let quillInstance = this.quill;
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/*');
                        input.click();
                        input.onchange = async function() {
                            const file      = input.files[0];
                            const reader    = new FileReader();
                            
                            const ImageSaveLoader = popinfo('loader', 'Loading Image', 'Please wait');
                            
                            reader.addEventListener('load', (event) => {

                                api(
                                    '/RichEditorImage','post', {
                                        imageName   : file.name
                                        ,imageData  : event.target.result
                                    }, 'Bearer ' + authToken
                                )
                                .then((response) => {
                                    ImageSaveLoader.close();

                                    const range = quillInstance.getSelection();

                                    this.quill.insertEmbed(range.index, 'image', response.url);
                                })
                                .catch((error) => {
                                    popinfo('error', 'Ooopss', error, {}, ImageSaveLoader);
                                })
                                
                            });
                            reader.readAsDataURL(file);

                        }.bind(this);
                    }
                } : {}
            }
        }, modules || {}) 
    });
}

export {QuillBuilder};